import React from "react";

import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import HeadingView from "common/views/heading/Heading.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { IDataTableColumn } from "common/views/table/DataTable";
import CatalogLabels from "../../Catalog.labels";
import { ICourseParams } from "../../entities/CourseParams";
import ICourseFragmentProps from "./ICourseFragmentProps";


export const main: IDataTableColumn<ICourseFragmentProps, ICourseParams> = {
	name: "Table Main",
	sort: "title",
	label: {k: "col.Title", v: "Title"},
	primary: true,
	enabled: ({course}) => !!course,
	component: ({course, actions}) => {
		return (
			<div>
				<HeadingView viewKey="course.col.main.title">{course.title}</HeadingView>
				<div>
					{true && (
						<PageLinkView params={{productId: course.id}} viewKey="subs.col.main.viewLink">
							<ButtonView variant={ButtonVariant.CARD_ACTION} viewKey="subs.col.main.details">
								<CatalogLabels.Labels.ViewDetails />
							</ButtonView>
						</PageLinkView>
					)}

					{course.canLaunch && (
						<ButtonView viewKey="subs.col.main.launch" variant={ButtonVariant.PRIMARY} onClick={() => actions.launchCourse(course)}>
							<CatalogLabels.Labels.LaunchCourse />
						</ButtonView>
					)}
				</div>
			</div>
		);
	},
	renderSkeleton: () => (
		<React.Fragment>
			<p className="bp3-skeleton" style={{height: "20px", marginBottom: "10px"}} />
			<p className="bp3-skeleton" style={{height: "25px"}} />
		</React.Fragment>
	)
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/course/compositeFragments.tsx